import ClientFilterModal from "pages/clientFilterModal/client-filter-modal";
import React, { useState } from "react";
import {
    Card,
    CardBody,
    Row,
    Col,
    Form,
    Input,
    Button,
    Label,
    FormGroup,
    Badge,
    Container,
} from "reactstrap";

const ClientDetails = () => {
    const [clientFilterModalOpen, setClientFilterModalOpen] = useState(true);
    const [active, setActive] = useState(null);


    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col md="8">
                        <h5 className="fw-bold mb-3">Call Details</h5>

                        {/* Main Card */}
                        <Card className="border mb-3">
                            <CardBody>
                                {/* Header */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="fw-bold mb-0">Jess Harper <Badge color="success" className="ms-2">
                                        Active
                                    </Badge></h6>
                                    <div>
                                        <small className="text-muted">
                                            <i className='fas fa-calendar'></i> Date Added: 09.20.2025
                                        </small>
                                    </div>
                                </div>

                                <hr />

                                {/* Client Info */}
                                <Row className="mb-3">
                                    <Col md="6" className="mb-2">
                                        <p className="mb-1">
                                            {/* <i className="bi bi-person-fill me-1"></i> */}
                                            <strong> <i className="fa fa-user me-1" aria-hidden="true"></i>
                                                Client:</strong> Funnl Test
                                        </p>
                                    </Col>
                                    <Col md="6" className="mb-2">
                                        <p className="mb-1">
                                            {/* <i className="bi bi-telephone-fill me-1"></i> */}
                                            <strong><i className="fa fa-phone me-1" aria-hidden="true"></i>
                                                Phone:</strong> Funnl Test
                                        </p>
                                    </Col>
                                    <Col md="6" className="mb-2">
                                        <p className="mb-1">
                                            <i className="fa fa-user me-1" aria-hidden="true"></i>
                                            <strong>Client:</strong> Funnl Test
                                        </p>
                                    </Col>
                                    <Col md="6" className="mb-2">
                                        <p className="mb-1">
                                            {/* <i className="bi bi-person-fill me-1"></i> */}
                                            <strong> <i className="fa fa-user me-1" aria-hidden="true"></i>
                                                Client:</strong> Funnl Test
                                        </p>
                                    </Col>
                                </Row>

                                {/* FedEx Form 1 */}
                                <Row className="mb-3">
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Fedex Id :</Label>
                                            <Input type="text" placeholder="Type" />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Send FADV link?</Label>
                                            <Input type="select">
                                                <option>No</option>
                                                <option>Yes</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        {/* FedEx Form 2 */}
                        <Card className="border mb-3">
                            <CardBody>
                                <Row className="align-items-end">
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Fedex Id :</Label>
                                            <Input type="text" placeholder="Type" />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label>Send FADV link?</Label>
                                            <Input type="select">
                                                <option>No</option>
                                                <option>Yes</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md="2">
                                        <Button color="primary" className="w-100 send-button-move">
                                            Send
                                        </Button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        {/* Quota */}
                        {/* Quota Section */}
                        <Card className="border mb-3">
                            <CardBody className="p-4">
                                <h6 className="fw-bold mb-3">Quota</h6>

                                <div
                                    className="d-flex align-items-center justify-content-start p-3"
                                    style={{
                                        border: "1px solid #dcdcdc",
                                        borderRadius: "4px",
                                        gap: "2rem",
                                    }}
                                >
                                    <div className="form-check d-flex align-items-center">
                                        <Input
                                            type="radio"
                                            name="quotaOption"
                                            id="fedexDriver"
                                            defaultChecked
                                            className="me-2"
                                            style={{
                                                accentColor: "#3f51b5", // blue ring color
                                                transform: "scale(1.2)",
                                            }}
                                        />
                                        <Label
                                            htmlFor="fedexDriver"
                                            check
                                            className="fw-bold mb-0"
                                            style={{ cursor: "pointer" }}
                                        >
                                            Is existing FedEx Driver?
                                        </Label>
                                    </div>

                                    <div className="form-check d-flex align-items-center">
                                        <Input
                                            type="radio"
                                            name="quotaOption"
                                            id="drivingExperience"
                                            className="me-2"
                                            style={{
                                                accentColor: "#3f51b5",
                                                transform: "scale(1.2)",
                                            }}
                                        />
                                        <Label
                                            htmlFor="drivingExperience"
                                            check
                                            className="fw-bold mb-0"
                                            style={{ cursor: "pointer" }}
                                        >
                                            Driving Experience?
                                        </Label>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>


                        {/* Screening Status */}
                        <Card className="border mb-3">
                            <CardBody className="p-4">
                                <h6 className="fw-bold mb-4">Screening Status</h6>

                                {/* ✅ Drug Screening */}
                                <div
                                    className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center p-3 mb-3 rounded"
                                    style={{ backgroundColor: "#f9fdfa", border: "1px solid #e6f4ea" }}
                                >
                                    <div className="d-flex flex-wrap align-items-center mb-2 mb-md-0">
                                        <span className="me-2" style={{ fontSize: "18px", color: "#2ecc71" }}>✓</span>
                                        <p className="fw-bold mb-0 me-3">Drug Screening</p>
                                        <p className="text-success mb-0" style={{ fontWeight: "500", whiteSpace: "nowrap" }}>
                                            Negative/Pass
                                        </p>
                                    </div>

                                    <Button
                                        className="mt-2 mt-md-0"
                                        style={{
                                            backgroundColor: "#0b144f",
                                            color: "#fff",
                                            border: "none",
                                            fontWeight: "500",
                                            padding: "6px 18px",
                                        }}
                                    >
                                        Change
                                    </Button>
                                </div>

                                {/* ✅ Dot Medical Card Rows */}
                                {[1, 2, 3].map((i) => (
                                    <div
                                        key={i}
                                        className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center p-3 mb-2 rounded"
                                        style={{ backgroundColor: "#fffaf3", border: "1px solid #ffe8c2" }}
                                    >
                                        <div className="d-flex flex-wrap align-items-center mb-2 mb-md-0">
                                            <span className="me-2" style={{ fontSize: "18px", color: "#f0ad4e" }}>⏱</span>
                                            <p className="fw-bold mb-0 me-3">Dot Medical Card</p>
                                            <p className="mb-0" style={{ color: "#f0ad4e", fontWeight: "500", whiteSpace: "nowrap" }}>
                                                Pending on Client’s End
                                            </p>
                                        </div>

                                        <div className="d-flex flex-wrap gap-2">
                                            <Button
                                                style={{
                                                    color: "#0b144f",
                                                    border: "none",
                                                    fontWeight: "500",
                                                    padding: "6px 18px",
                                                    backgroundColor: "#eef0ff",
                                                }}
                                            >
                                                Change
                                            </Button>
                                            <Button
                                                style={{
                                                    backgroundColor: "#0b144f",
                                                    color: "#fff",
                                                    border: "none",
                                                    fontWeight: "500",
                                                    padding: "5px 12px",
                                                }}
                                            >
                                                Upload MEC
                                            </Button>
                                        </div>
                                    </div>
                                ))}
                            </CardBody>
                        </Card>


                        {/* ⭐ SPECIAL NOTES */}
                        <Card className="border mb-3">
                            <CardBody>
                                {/* ⭐ SPECIAL NOTES */}
                                <h6 className="fw-bold mb-2">Special Notes</h6>
                                <Input
                                    type="textarea"
                                    rows="3"
                                    className="mb-3"
                                    placeholder="Enter special notes..."
                                />

                                {/* ⭐ CLIENT FEEDBACK */}
                                <h6 className="fw-bold mb-2">Client Feedback</h6>
                                <div className="p-3 rounded mb-3" style={{ background: "#fafafa", border: "1px solid #eee" }}>
                                    Funnl Test - REJECTED [3:32 AM 10-17-2025] : test reject
                                </div>

                                {/* ⭐ CALL STATUS + SCHEDULE DATE */}
                                <Row className="align-items-end">
                                    <Col md="6">
                                        <Label className="fw-bold">Call Status <span className="text-danger">*</span></Label>
                                        <Input type="select" className="mb-3">
                                            <option>Select Call Status</option>
                                        </Input>
                                    </Col>

                                    <Col md="3">
                                        <Label className="fw-bold">Schedule Date</Label>
                                        <Input type="date" className="mb-3" />
                                    </Col>

                                    <Col md="3">
                                        <Label className="fw-bold">Time</Label>
                                        <Input type="time" className="mb-3" />
                                    </Col>
                                </Row>

                                {/* ⭐ NOTES */}
                                <h6 className="fw-bold">Notes <span className="text-danger">*</span></h6>
                                <Input type="textarea" rows="3" className="mb-4" />
                            </CardBody>
                        </Card>

                        {/* ⭐ CALL INFO ACCORDION */}
                        <Card className="border mb-3">
                            <CardBody>
                                <h6 className="fw-bold mb-3">Call Info</h6>

                                <div className="accordion">

                                    {/* === Item 1 === */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button
                                                className={`accordion-button ${active === 1 ? "" : "collapsed"}`}
                                                type="button"
                                                onClick={() => setActive(active === 1 ? null : 1)}
                                            >
                                                3:28 AM 10-17-2025
                                                <Badge color="success" className="ms-2">Eligible</Badge>
                                            </button>
                                        </h2>

                                        <div className={`accordion-collapse collapse ${active === 1 ? "show" : ""}`}>
                                            <div className="accordion-body">
                                                submit by Nupoor Singh <br />
                                                <strong className="mt-2 d-block">test</strong>
                                            </div>
                                        </div>
                                    </div>

                                    {/* === Item 2 === */}
                                    <div className="accordion-item mt-2">
                                        <h2 className="accordion-header">
                                            <button
                                                className={`accordion-button ${active === 2 ? "" : "collapsed"}`}
                                                type="button"
                                                onClick={() => setActive(active === 2 ? null : 2)}
                                            >
                                                3:27 AM 10-17-2025
                                                <Badge color="info" className="ms-2">Schedule</Badge>
                                            </button>
                                        </h2>

                                        <div className={`accordion-collapse collapse ${active === 2 ? "show" : ""}`}>
                                            <div className="accordion-body">
                                                submit by Nupoor Singh
                                            </div>
                                        </div>
                                    </div>

                                    {/* === Item 3 === */}
                                    <div className="accordion-item mt-2">
                                        <h2 className="accordion-header">
                                            <button
                                                className={`accordion-button ${active === 3 ? "" : "collapsed"}`}
                                                type="button"
                                                onClick={() => setActive(active === 3 ? null : 3)}
                                            >
                                                3:27 AM 10-17-2025
                                                <Badge color="success" className="ms-2">Complete</Badge>
                                            </button>
                                        </h2>

                                        <div className={`accordion-collapse collapse ${active === 3 ? "show" : ""}`}>
                                            <div className="accordion-body">
                                                submit by Nupoor Singh
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </CardBody>
                        </Card>





                    </Col>

                    {/* Right Section */}
                    <Col md="4">
                        <h5 className="fw-bold mb-3">Client Details</h5>

                        {/* Recruiting Contact */}
                        <Card className="border mb-3">
                            <CardBody>
                                <h6 className="fw-bold text-primary mb-2">
                                    Recruiting Contact
                                </h6>
                                <p className="mb-1">
                                    <strong>Company Name:</strong> Funni Test
                                </p>
                                <p className="mb-0">
                                    <strong>Name:</strong> Nupoor Singh
                                </p>
                            </CardBody>
                        </Card>

                        {/* Billing Contacts */}
                        {[1, 2, 3].map((i) => (
                            <Card key={i} className="border mb-3">
                                <CardBody>
                                    <h6 className="fw-bold text-primary mb-2">Billing Contact</h6>
                                    <p className="mb-1">
                                        <strong>Terminal Address:</strong> Test Kolkata
                                    </p>
                                    <p className="mb-1">
                                        <strong>Entity ID:</strong> Funni Test
                                    </p>
                                    <p className="mb-0">
                                        <strong>Routes:</strong> 5
                                    </p>
                                </CardBody>
                            </Card>
                        ))}
                    </Col>


                </Row>
                <Col xl="8">
                    <Row>
                        <Col md="4" >
                            <Card className="mini-stats-wid">
                                <CardBody>
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-0">{'8'}</h4>
                                            <p className="text-muted fw-medium">
                                                {'Reviewed'}
                                            </p>
                                        </div>
                                        <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                                            <span className="avatar-title rounded-circle bg-primary">
                                                <i className={"bx " + "bx-copy-alt" + " font-size-24"}></i>
                                            </span>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Col>
                <ClientFilterModal setClientFilterModalOpen={setClientFilterModalOpen} clientFilterModalOpen={clientFilterModalOpen} />

            </Container>
        </div>
    );
};

export default ClientDetails;
